import React, { useState } from 'react';
import { Redirect } from 'react-router-dom';
import _ from 'lodash';
import { Typography, Divider } from '@telus-uds/components-web';

import PdfActivityReport from './pdfActivity';
import EmailActivityReport from './emailActivity';
import OrderActivityReport from './orderActivity';
import CombinedActivityReport from './combinedActivity';
import BlackFridaySpecialReport from './blackFridaySpecial';
import DateRangeComparison from './dateRangeComparison';
import ApiRequestsReport from './apiRequests';
import ExportHistoryReport from './exportHistory';
import request from '../utils/request';
import useReportingStrings from './utils/useReportingStrings';

const BlackFridayReports = () => {
  const strings = useReportingStrings();
  const [tabSelected, setTabSelected] = useState('COMBINED');

  // The reports module is ADMIN-only. Checked at render time (not at module import) so a profile
  // change mid-session is respected; no report API call is made for any other role.
  if (_.get(request.getProfile(), 'role.name') !== 'ADMIN') {
    return <Redirect to="/" />;
  }

  const tabs = [
    { key: 'COMBINED', label: 'Dashboard' },
    { key: 'BLACK_FRIDAY', label: 'Black Friday Report' },
    { key: 'ORDER_ACTIVITY', label: 'Order Activity' },
    { key: 'PDF_ACTIVITY', label: 'PDF Reports' },
    { key: 'EMAIL_ACTIVITY', label: 'Email Reports' },
    { key: 'API_REQUESTS', label: 'API Activity' },
    { key: 'COMPARISON', label: 'Compare Periods' },
    { key: 'EXPORT_HISTORY', label: 'Export History' }
  ];


  const renderTabContent = () => {
    switch (tabSelected) {
      case 'PDF_ACTIVITY':
        return <PdfActivityReport />;
      case 'EMAIL_ACTIVITY':
        return <EmailActivityReport />;
      case 'ORDER_ACTIVITY':
        return <OrderActivityReport />;
      case 'COMBINED':
        return <CombinedActivityReport />;
      case 'BLACK_FRIDAY':
        return <BlackFridaySpecialReport />;
      case 'COMPARISON':
        return <DateRangeComparison />;
      case 'API_REQUESTS':
        return <ApiRequestsReport />;
      case 'EXPORT_HISTORY':
        return <ExportHistoryReport />;
      default:
        return <CombinedActivityReport />;
    }
  };

  return (
    <div className="container 85%" style={{ padding: '2rem' }}>
      <Typography heading="h2" variant={{ size: 'h2' }} block>{strings.heading}</Typography>
      <div
        style={{
          marginTop: '2rem',
          borderBottom: '1px solid #e4e4e4',
          padding: '0 2rem'
        }}
      >
        <ul
          style={{
            display: 'flex',
            gap: '1rem',
            flexWrap: 'nowrap',
            overflowX: 'auto',
            WebkitOverflowScrolling: 'touch',
            listStyle: 'none',
            margin: 0,
            padding: 0
          }}
        >
          {tabs.map(tab => (
            <li
              key={tab.key}
              role="tab"
              tabIndex={0}
              aria-selected={tabSelected === tab.key}
              style={{
                padding: '1rem 1.5rem',
                borderRadius: '6px 6px 0 0',
                background: tabSelected === tab.key ? '#4b286d' : '#ffffff',
                borderTop:
                  tabSelected === tab.key
                    ? '2px solid #4b286d'
                    : '1px solid #e4e4e4',
                borderLeft:
                  tabSelected === tab.key
                    ? '2px solid #4b286d'
                    : '1px solid #e4e4e4',
                borderRight:
                  tabSelected === tab.key
                    ? '2px solid #4b286d'
                    : '1px solid #e4e4e4',
                borderBottom: 0,
                color: tabSelected === tab.key ? '#ffffff' : '#454545',
                fontWeight: tabSelected === tab.key ? '500' : '400',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                flexShrink: 0,
                whiteSpace: 'nowrap'
              }}
              onClick={() => setTabSelected(tab.key)}
              onKeyDown={e => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                  setTabSelected(tab.key);
                }
              }}
            >
              {tab.label}
            </li>
          ))}
        </ul>
      </div>
      <Divider />
      <div style={{ padding: '2rem 0' }}>{renderTabContent()}</div>
    </div>
  );
};

export default BlackFridayReports;
